export enum EFormPaymentTestPMToken {
  success = 'pm_card_us',
  authReq = 'pm_card_authenticationRequiredOnSetup',
  declined = 'pm_card_chargeDeclined',
}

export enum EFormPaymentTestKonbiniNumber {
  succeededIn3Minutes = '11111111110',
  succeededImmediately = '22222222220',
  expiresImmediately = '33333333330',
  expiresIn3Minutes = '44444444440',
  neverSucceeds = '55555555550',
  numberError1 = '01234567890',
  numberError2 = '00000000000',
}
